/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import Button from "ui/kit/buttons/Button";
import AuthenticationContext from "state/authentication";

const SignOutButton: React.FC = () => {
    const authenticationContext = React.useContext(AuthenticationContext);
    const handleSignOut = React.useCallback(async () => {
        await authenticationContext.setAccessToken(null);
    }, [authenticationContext]);
    return <Button onClick={handleSignOut} purpose={"destructure"} title={"Sign Out"}/>
}

export default SignOutButton;